class ColorPicker2 {

	constructor(id) {
		this.id = id;
		this.color = "4435CC";

		this.h = 0;
		this.s = 1;
		this.v = 1;

		this.setting = null;

		this._onChange = null;
		this._onComplete = null;

		this.elem = div('color-picker', [
			this.hsEl = div('color-picker-hs', '<i></i>', {
				'mousedown touchstart': this.prepDrag.bind(this, 'hs')
			}),
			this.vEl = div('color-picker-v', '<i></i>', {
				'mousedown touchstart': this.prepDrag.bind(this, 'v')
			})
		]);

		this.hsPt = this.hsEl.firstChild.style;
		this.vPt = this.vEl.firstChild.style;
	}
	set HSV(aValue) {
		this.h = aValue[0] / 360;
		this.s = aValue[1] / 100;
		this.v = aValue[2] / 100;
		this.prev();
	}
	set RGB(aValue) {
		aValue = this.rgb2hsv(aValue[0], aValue[1], aValue[2]);
		this.h = aValue[0];
		this.s = aValue[1];
		this.v = aValue[2];
		this.prev();
	}
	set HEX(sValue) {
		if (sValue[0] === '#') sValue = sValue.slice(1);
		this.RGB = this.hex2rgb(sValue);
	}
	get HEX() {
		let rgb = this.hsv2rgb(this.h, this.s, this.v);
		return this.rgb2hex(rgb[0], rgb[1], rgb[2]);
	}
	random() {
		this.h = Math.random();
		this.s = Math.random() * 0.3 + 0.6;
		this.v = 0.8;
		return this;
	}
	setPopup() {
		this._popup = Dialog.Popup(this.id, this.elem).sticky();
	}
	toggle(button, onChange, onComplete) {
		if (typeof onChange === 'function') this._onChange = onChange;
		this._popup.onHide = onComplete || null;
		this._popup.handle(button);
	}
	close() {
		this._popup.close();
	}
	onChange (callback, callbackObj) {
		if (typeof(callbackObj) !== 'undefined') this._onChange = callback.bind(callbackObj);
		else this._onChange = callback;
	}
	changed () {
		if (this._onChange) this._onChange(this.HEX);
	}
	prev () {
		this.hsPt.left = (this.h) * this.hsEl.offsetWidth - 4 + 'px';
		this.hsPt.top = (1 - this.s) * this.hsEl.offsetHeight - 4 + 'px';
		this.vPt.top = (1 - this.v) * this.vEl.offsetHeight - 3 + 'px';
		this.vEl.style.backgroundColor = 'rgb(' + this.hsv2rgb(this.h, this.s, 1).join(',') + ')';
		this.changed();
	}
	getElem () {
		return this.elem;
	}
	prepDrag (setting, ev){
		this.setting = setting;
		startDrag(ev || window.event, this);
		this.drag();
	}
	drag () {
		switch (this.setting) {
			case 'hs':
				this.h = limit(pointInElem(this.hsEl).x, 0, this.hsEl.offsetWidth)
					/ this.hsEl.offsetWidth;
				this.s = 1 - (limit(pointInElem(this.hsEl).y, 0, this.hsEl.offsetHeight)
					/ this.hsEl.offsetHeight);
				break;
			case 'v':
				this.v = 1 - (limit(pointInElem(this.vEl).y, 0, this.vEl.offsetHeight)
					/ this.vEl.offsetHeight);
				break;
		}
		this.prev();
	}
	hsv2rgb (h, s, v) {
		let i, f, p, q, t;
		let r, g, b;
		i = Math.floor(h * 6);
		f = h * 6 - i;
		p = v * (1 - s);
		q = v * (1 - f * s);
		t = v * (1 - (1 - f) * s);
		i = i || 0;
		q = q || 0;
		t = t || 0;
		switch (i % 6) {
			case 0:r = v; g = t; b = p;break;
			case 1:r = q; g = v; b = p;break;
			case 2:r = p; g = v; b = t;break;
			case 3:r = p; g = q; b = v;break;
			case 4:r = t; g = p; b = v;break;
			default:r = v; g = p; b = q; // case 5
		}

		return [
			Math.max(0, Math.min(Math.floor(r * 256), 255)),
			Math.max(0, Math.min(Math.floor(g * 256), 255)),
			Math.max(0, Math.min(Math.floor(b * 256), 255))
		];
	}
	rgb2hsv (r, g, b){
		r /= 255; g /= 255; b /= 255;

		let max = Math.max(r, g, b), min = Math.min(r, g, b);
		let h, s, v = max, d = max - min;

		s = max === 0 ? 0 : d / max;

		if (max === min) {
			h = 0;
		}
		else {
			switch (max) {
				case r:
					h = (g - b) / d + (g < b ? 6 : 0);
					break;
				case g:
					h = (b - r) / d + 2;
					break;
				case b:
					h = (r - g) / d + 4;
					break;
			}
			h /= 6;
		}
		return [h, s, v];
	}
	hex2rgb (hex){
		if (hex.length === 3) {
			hex = hex.replace(/./g, '$&$&');
		}
		return [parseInt(hex[0] + hex[1], 16), parseInt(hex[2] + hex[3], 16), parseInt(hex[4] + hex[5], 16)];
	}
	rgb2hex (r, g, b){
		let s = +b | (+g << 8) | (+r << 16);
		s = '000000' + s.toString(16);
		return s.slice(-6);
	}
}